<!--
 * @Autor: zhiying Qin
 * @Date: 2025-04-14 23:08:52
 * @LastEditTime: 2025-04-16 23:36:31
-->
<template>
    <div class="login">
        <h1>重置密码</h1>

        <van-form @submit="onSubmit" class="form-block">
            <van-field v-model="username" name="phone" placeholder="请输入手机号" class="form-item" />
            <van-field v-model="password" type="password" name="password" placeholder="请输入需要更改的密码" class="form-item" />
            <van-field v-model="password2" type="password" name="password2" placeholder="请确认您输入的密码" class="form-item" />
            <div style="margin: 16px 0px;">
                <van-button round block type="danger" native-type="submit" :loading="loading">确认修改</van-button>
                <!-- <van-button round block type="info" native-type="submit" :loading="loading"></van-button> -->
                <!-- <div class="text">忘记密码</div> -->

            </div>
        </van-form>
    </div>
</template>

<script>
import { login ,updatePassword} from "@/api/xicaiquan";
// import {  } from '@/api/activity';
import tools from "@/libs/utils";
import { Toast } from "vant";
export default {
    name: "login",
    data() {
        return {
            username: "",
            password: "",
            password2: '',
            loading: false,
        };
    },
    created() { },
    components: {},
    watch: {},
    methods: {
        async login(data) {
            this.loading = true;
            const res = await login(data);
            this.loading = false;
            console.log(res);
            if (res.code == 200) {
                tools.setToken1(res.data.tokenValue);
                this.$router.go(-1);
            }
        },

        onSubmit(values) {
            if (values.password != values.password2) {
                Toast('两次密码输入不一致')
                return
            }
            // console.log({ phone: values.phone, password: values.password },'===')
            // return
            updatePassword({ phone: values.phone, password: values.password }).then(res => {
                if (res.code == 200) {
                    Toast('修改成功')
                    this.$router.replace({ path: "/login" });
                }
            })
            // this.login(values);
            // return
            console.log("submit", values);
        },
    },
};
</script>
<style scoped lang="scss">
h1 {
    text-align: center;
    margin: 30px auto;
}

.login {
    height: 100vh;
    background: #fff;
    overflow: hidden;
}

.form-block {
    width: 90%;
    margin: 0px auto;

    /deep/ .form-item {
        margin: 20px 0px;
        background: #e8eef1;
        border-radius: 10px;
    }
}

.text {
    width: 100%;
    text-align: center;
    line-height: 50px;
    font-weight: bold;
    color: #1989fa;
}
</style>